import { render, staticRenderFns } from "./registerhead.vue?vue&type=template&id=33f23f44&scoped=true&"
import script from "./registerhead.vue?vue&type=script&lang=js&"
export * from "./registerhead.vue?vue&type=script&lang=js&"
import style0 from "./registerhead.vue?vue&type=style&index=0&id=33f23f44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f23f44",
  null
  
)

export default component.exports